export function PageProgress({ page }) {
  return (
    <div className="page-progress" aria-label={`Page ${page} of 2`}>
      <div className={`progress-step ${page === 1 ? 'active' : page > 1 ? 'done' : ''}`}>
        <span className="progress-dot" />
        <span>Page 1</span>
      </div>
      <div className="progress-line" />
      <div className={`progress-step ${page === 2 ? 'active' : ''}`}>
        <span className="progress-dot" />
        <span>Page 2</span>
      </div>
    </div>
  );
}
